var _style, _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C165.2,0,85.5,47.2,40,118.5l347.2,357.4C461.9,431.1,512,349.4,512,256C512,114.6,397.4,0,256,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512,256c0-66.4-25.3-126.9-66.8-172.4v344.9C486.7,382.9,512,322.4,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.8,481.9l26.8,0l8.3-25.5l8.3,25.5l13.5,0c8.2-4.4,16.2-9.3,23.9-14.5L44.7,111.5 c-5.9,8.6-11.2,17.5-16,26.8l3.2,9.7l26.8,0L37,163.7l8.3,25.5l-21.7-15.7l-12.9,9.4C3.7,206,0,230.6,0,256 c0,141.4,114.6,256,256,256c29.9,0,58.6-5.1,85.3-14.6L319.8,481.9z M57.1,244.9l8.3-25.5l-21.7-15.8l26.8,0l8.3-25.5l8.3,25.5 l26.8,0l-21.7,15.8l8.3,25.5l-21.7-15.7L57.1,244.9z M112.3,300.5l8.3-25.5l-21.7-15.8l26.8,0l8.3-25.5l8.3,25.5l26.8,0L147.4,275 l8.3,25.5L134,284.7L112.3,300.5z M167.5,356.2l8.3-25.5l-21.7-15.8l26.8,0l8.3-25.5l8.3,25.5l26.8,0l-21.7,15.8l8.3,25.5 l-21.7-15.8L167.5,356.2z M244.5,396.1l-21.7,15.8l8.3-25.5l-21.7-15.8l26.8,0l8.3-25.5l8.3,25.5l26.8,0l-21.7,15.8l8.3,25.5 L244.5,396.1z M278,467.5l8.3-25.5l-21.7-15.8l26.8,0l8.3-25.5l8.3,25.5l26.8,0L313.1,442l8.3,25.5l-21.7-15.8L278,467.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/ba.f3233ec783f803b35c05036594cdbf09.svg";
export { ForwardRef as ReactComponent };